module.exports = __webpack_public_path__ + "images/sgp/SGPHero/large-self-storage-hero.webp";